"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertGiftToInvitationType = exports.convertInvitationTypes = exports.convertInvitationType = void 0;

var _ramda = require("ramda");

var convertInvitationType = (0, _ramda.applySpec)({
  id: (0, _ramda.path)(['gift_invitation_item', 'type_id']),
  name: (0, _ramda.path)(['gift_invitation_item', 'type']),
  image: (0, _ramda.path)(['gift_invitation_item', 'image']),
  messageTextLimit: (0, _ramda.path)(['gift_invitation_item', 'chars_limit']),
  contactAddress: (0, _ramda.path)(['gift_invitation_item', 'contact_address']),
  isAddressRequired: (0, _ramda.always)(false)
});
exports.convertInvitationType = convertInvitationType;
var convertInvitationTypes = (0, _ramda.map)((0, _ramda.applySpec)({
  id: (0, _ramda.prop)('id'),
  name: (0, _ramda.prop)('name'),
  image: (0, _ramda.prop)('image'),
  isAddressRequired: (0, _ramda.prop)('is_address_required'),
  messageTextLimit: (0, _ramda.always)(null),
  contactAddress: (0, _ramda.always)(null),
  remaining: (0, _ramda.prop)('remaining'),
  allowedForCountry: (0, _ramda.prop)('allowedForCountry'),
  isAvailable: (0, _ramda.prop)('isAvailable'),
  description: (0, _ramda.prop)('description')
}));
exports.convertInvitationTypes = convertInvitationTypes;
var convertGiftToInvitationType = (0, _ramda.applySpec)({
  isSaved: (0, _ramda.pathSatisfies)(Boolean, ['gift_invitation_item', 'type_id']),
  selectedInvitationType: (0, _ramda.ifElse)((0, _ramda.pathSatisfies)(Boolean, ['gift_invitation_item', 'type_id']), convertInvitationType, (0, _ramda.always)(null))
});
exports.convertGiftToInvitationType = convertGiftToInvitationType;